import React, { useState, useCallback } from 'react';
import { Row, Button, message } from 'antd';
import { calculatePercent } from './utils';
import * as numeral from 'numeral';
import TopupModal from './topupModal';
import { authenticatedApiFetch, getMessageID } from '../../../common/helpers';
import PropTypes from 'prop-types';
import '../fundingLimit.less';
import { MAX_USE_LIMIT, SUCCESS_STATUS } from '../constants';

const AmountCard = ({ cardData: { balance, lender_limit_snapshot, lender_id }, productID, translate }) => {
  const usedPercent = calculatePercent(balance, lender_limit_snapshot);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const title=translate('fundingLimit.disbursed')
  const topupTitle=translate('fundingLimit.edit')

  const handleTopup = useCallback((values) => {
    const params = {
      target_balance_amount: parseFloat(values.projection_amount),
      alert_threshold_amount: parseFloat(values.threshold_amount),
      lender_id,
      product_id: productID
    };

    const payload = {
      "msg_id": getMessageID(),
      "wallet_balances": [params]
    }


    authenticatedApiFetch(`wallet_topup`, 'POST', payload)
      .then((res) => {
        if (res.status === SUCCESS_STATUS) {
          message.success(translate('fundingLimit.lender_limit_updated'));
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        } else {
          message.error(translate('fundingLimit.lender_limit_update_failed'));
        }
      })
      .catch((err) => {
        message.error(`${translate('fundingLimit.lender_limit_update_failed')}: ${err.message}`);
      });
  }, [lender_id, translate]);

  return (
    <div>
      <Row className='amount-card-row'>
        {title}
      </Row>
      <Row className='amount-card-row'>
        <Button style={{marginRight: 16}} type="primary" onClick={() => setIsModalOpen(true)}>
          {topupTitle}
        </Button>
        <span style={{marginRight: 16}} className={`funding-card-title-right-status ${usedPercent > MAX_USE_LIMIT ? "funding-card-title-right-status-alert" : ""}`}>{usedPercent}% used</span>
        <p> {`RP ${numeral(balance).format('0,0')}` } / {`${numeral(lender_limit_snapshot).format('0,0')}` } </p>
      </Row>
      <TopupModal translate={translate} isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} onSubmit={handleTopup} />
    </div>
  );
}

AmountCard.propTypes = {
  cardData: PropTypes.shape({
    balance: PropTypes.number.isRequired,
    lender_limit_snapshot: PropTypes.number.isRequired,
    lender_id: PropTypes.string.isRequired,
  }).isRequired,
  translate: PropTypes.func.isRequired,
};

export default AmountCard;
